import { Box, ButtonOutline } from 'front-end/src/components'
import IconExclamation from 'front-end/src/components/common/icon/IconExclamation'
import { OrganisationCalendars } from 'front-end/src/graphql/public/PublicSchemaTypes'
import { useGetCalendarIntegrationsForOrganisationQuery } from 'front-end/src/pages/account/authentication-tab/AuthenticationTab.codegen'
import {
  CalendarIntegrationEnum,
  defaultIntegrationOption
} from 'front-end/src/pages/account/authentication-tab/calendar-integrations/CalendarIntegrations'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'
import React, { FC } from 'react'

import { BoxProps, Flex } from '@chakra-ui/react'
import { Trans, t } from '@lingui/macro'

import {
  usePushUnSyncedEventMutation,
  useUnSyncedFutureEventQuery
} from './SyncGeneralAlert.codegen'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

export const SyncGeneralAlert: FC<
  BoxProps & {
    eventId: number
    isPublished: boolean
  }
> = (props) => {
  const { isAdmin } = usePublicApiSession()
  const { theme } = useLooopTheme()
  const { eventId, isPublished, ...rest } = props

  const [pushUnSyncedEvent, { loading }] = usePushUnSyncedEventMutation({
    variables: {
      eventId
    }
  })
  const { data, refetch } = useUnSyncedFutureEventQuery({
    variables: {
      eventId
    }
  })

  const showSyncAlert = !!data?.admin?.event?.unSyncedEvent

  const { data: calendarsData } =
    useGetCalendarIntegrationsForOrganisationQuery()

  const calendars = calendarsData?.admin?.organisation?.calendars
  const integration = defaultIntegrationOption(
    calendars as OrganisationCalendars
  )

  return isAdmin && isPublished && showSyncAlert ? (
    <Flex
      bgColor={theme.colors.yellow['50']}
      borderRadius={theme.radii.base}
      flexDirection="column"
      justifyContent="flex-end"
      flexWrap="wrap"
      padding="12px"
      {...rest}
    >
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          order: 1,
          flexGrow: 0
        }}
      >
        <Box
          style={{
            margin: '4px 12px 0px 0px'
          }}
        >
          <IconExclamation color={theme.colors.grey[700]} />
        </Box>
        <Box>
          <Trans>This event does not appear to be on your calendar</Trans>
        </Box>
      </Box>

      <ButtonOutline
        style={{
          flex: 'none',
          order: 1,
          flexGrow: 1,
          marginTop: '12px'
        }}
        flexGrow={1}
        isLoading={loading}
        loadingText={t`Processing...`}
        onClick={async () => {
          await pushUnSyncedEvent()
          await refetch()
        }}
      >
        <Trans>
          Sync with{' '}
          {integration === CalendarIntegrationEnum.GOOGLE
            ? 'Google Calendar'
            : 'MS calendar'}
        </Trans>
      </ButtonOutline>
    </Flex>
  ) : null
}
